module.exports = __webpack_public_path__ + "static/media/404.2a1bfcab.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/404.png
// module id = 1173
// module chunks = 0